import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';
import Link from 'components/link';
import cn from 'classnames';

const topImageSizeBaseClass = 'image_size_top-image';

const getImageSources = isDoubleImage => {
  const multiplier = isDoubleImage ? 1 : 2;

  return [
    // Mobile devices
    {
      width: isDoubleImage ? 350 : 390,
      height: isDoubleImage ? 231 : 266,
      media: 390,
    },
    {
      width: isDoubleImage ? 390 : 430,
      height: isDoubleImage ? 258 : 293,
      media: 430,
    },
    {
      width: 364 * multiplier,
      height: isDoubleImage ? 380 : 360,
      media: 768,
    },
    // Tablet devices
    {
      width: 492 * multiplier,
      height: 486,
      media: 1024,
    },
    // Desktop devices
    {
      width: 620 * multiplier,
      height: 613,
      media: 1280,
    },
    {
      width: 664 * multiplier,
      height: 656,
      media: 1366,
    },
    {
      width: 820 * multiplier,
      height: 810,
      media: 1920,
    },
  ];
};

const TopImageBlock = ({
  image1,
  image2,
  place,
  imageCaption,
  highResPhotoDownloadLink,
}) => {
  const isDoubleImage = image1 && image2 ? true : false;
  const imageSizeClass = isDoubleImage
    ? place
      ? `${topImageSizeBaseClass}-half-${place}`
      : `${topImageSizeBaseClass}-half`
    : place
      ? `${topImageSizeBaseClass}-${place}`
      : topImageSizeBaseClass;

  return (
    <div
      className={cn('top-image-block', {
        'top-image-block_two-images': isDoubleImage,
      })}
    >
      <div
        className={cn('top-image-block__container', {
          [`top-image-block__container_in-${place}`]: place,
        })}
      >
        <div className="top-image-block__images">
          {image1 && (
            <div className="top-image-block__image">
              <Image
                {...image1}
                className={imageSizeClass}
                sources={getImageSources(isDoubleImage)}
                fetchPriority="high"
              />
            </div>
          )}
          {image2 && (
            <div className="top-image-block__image">
              <Image
                {...image2}
                className={imageSizeClass}
                sources={getImageSources(isDoubleImage)}
                fetchPriority="high"
              />
            </div>
          )}
          {highResPhotoDownloadLink && (
            <div className="top-image-block__high-res-photo-link-holder">
              <Link
                {...highResPhotoDownloadLink}
                className="top-image-block__high-res-photo-link"
              />
            </div>
          )}
        </div>
        {imageCaption && (
          <div className="top-image-block__image-caption">{imageCaption}</div>
        )}
      </div>
    </div>
  );
};

TopImageBlock.propTypes = {
  place: PropTypes.string,
  image1: PropTypes.exact(Image.propTypes),
  image2: PropTypes.exact(Image.propTypes),
  imageCaption: PropTypes.string,
  highResPhotoDownloadLink: PropTypes.exact(Link.propTypes),
};

export default TopImageBlock;
